import React, { useEffect, useRef, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { Link, useNavigate } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import data from './data/live.json';
import { parse } from 'date-fns';

const Live = () => {
    const navigate = useNavigate();
    const parseTime = (x) => {
        return parse(x, 'dd/MM/yyyy H:mm', new Date());
    };//MMMM d, yyyy h:mm a

    let nextEvents = [...data.events].filter(x => parseTime(x.time).getTime() > Date.now());
    nextEvents.sort((a, b) => parseTime(a.time) - parseTime(b.time));

    let passedEvents = [...data.events].filter(x => parseTime(x.time).getTime() < Date.now());
    passedEvents.sort((a, b) => - parseTime(a.time) + parseTime(b.time));

    return (
        <div className='w-full jana-background-contact text-200'>
            <div className='flex flex-column m-auto w-full p-3 pt-3 pb-6 lg:w-7 text-shadow' style={{minHeight: '70vh'}}>
                <div>
                    <h1>Live music</h1>
                    {data.intro && <ReactMarkdown>{data.intro}</ReactMarkdown>}
                    {nextEvents.length > 0 && <>Following dates :</>}
                    {nextEvents.length > 0 ? 
                        nextEvents.map((event, index) => (
                            <div key={index} className='pt-3'>
                                • <span>{parseTime(event.time).toLocaleString("en-US", {
                                    month: 'long',  // Full month name
                                    day: 'numeric', // Two-digit day
                                    year: 'numeric', // Full numeric year
                                    hour: 'numeric', // Two-digit hour
                                    minute: '2-digit', // Two-digit minutes
                                })}</span>:&nbsp;<strong>{event.name}</strong>&nbsp;
                                <span className='text-400'>,</span> {event.address}
                                {(event.details && event.details.length > 0) &&
                                    <><br />{event.details}</>
                                }
                            </div>
                    )) : <p>No concert in the next month.</p>}
                    <p>Follow me on <Link className='text-300' target="_blank" rel="noopener noreferrer" to='https://instagram.com/jana_pelikan'>Instagram</Link> to stay updated !</p>

                    {passedEvents.length > 0 && <>
                        <div className='text-500 pt-3 mt-5' style={{borderTop: '1px solid white'}}>
                            Previous dates :

                            {passedEvents.map((event, index) => (
                                <div key={index} className='pt-3'>
                                    • <span>{parseTime(event.time).toLocaleString("en-US", {
                                        month: 'long',  // Full month name
                                        day: 'numeric', // Two-digit day
                                        year: 'numeric', // Full numeric year
                                        hour: 'numeric', // Two-digit hour
                                        minute: '2-digit', // Two-digit minutes
                                    })}</span>:&nbsp;<strong>{event.name}</strong>&nbsp;
                                    <span className='text-400'>,</span> {event.address}
                                    {(event.details && event.details.length > 0) &&
                                        <><br />{event.details}</>
                                    }
                                </div>
                            ))}
                        </div>
                    </>}
                </div>
            </div>
        </div>
    );
};

export default Live;
